import React from "react";

export default function ExcelExport(props) {

    return  <div className="d-none">
              <table id="my-table" border="1">
                  <thead>
                      <tr>
                      {
                          props.columns && props.columns.map((item, index) => {
                              let condition = item.field !== "follow" && item.field !== "madeForCompany" && (props.type === "closed" || item.field !== "budget");
                              if(condition){
                                  return <th key={index}>{item.headerName}</th>
                              }
                          })
                      }
                      </tr>
                  </thead>
                  <tbody>
                      {
                          props.tableRows && props.tableRows.map((item, index) => {
                              return (
                                  <tr key={index}>
                                      {props.columns && props.columns.map((col, i) => {
                                          let condition = col.field in item && col.field !== "madeForCompany" && (props.type === "closed" || col.field !== "budget");
                                          if(condition){
                                              let cellValue = item[col.field];
                                              // Handle משוב column when type is closed
                                              if(col.field === "options" && props.type === "closed"){
                                                  cellValue = item[col.field] ? "בוצע" : "לא בוצע";
                                              }
                                              return <td key={i}>{cellValue}</td>
                                          }
                                      })}
                                  </tr>
                              )
                          })
                      }
                  </tbody>
              </table>
          </div> 
}